import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getSelectedCatalogItemsTotal } from 'entities/CatalogItem/model/selectors/catalogItemSelectors';
import { getUserCanSeePrices } from 'entities/User/model/selectors/userPermissionsSeletors';

interface CatalogItemsSelectedCounterProps {
    total?: string;
    title?: string;
    align?: 'start' | 'end';
}

export const CatalogItemsSelectedCounter = ({
    total,
    title,
    align = 'end',
}: CatalogItemsSelectedCounterProps) => {
    const { t } = useTranslation();
    const totalItemsCount = useSelector(getSelectedCatalogItemsTotal);
    const canSeePrices = useSelector(getUserCanSeePrices);

    const selectionLabel =
        title != null && title !== ''
            ? `${title}: ${totalItemsCount}`
            : t('{{count}} item selected', { count: totalItemsCount });

    const isStart = align === 'start';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                justifyContent: isStart ? 'flex-start' : 'flex-end',
                minHeight: totalItemsCount > 0 ? '24px' : 0,
            }}
        >
            {totalItemsCount > 0 && (
                <>
                    <Typography
                        textAlign={isStart ? 'left' : 'right'}
                        variant="body2"
                        sx={{ color: 'common.black' }}
                    >
                        {selectionLabel}
                    </Typography>
                    {canSeePrices && total ? (
                        <Typography
                            textAlign={isStart ? 'left' : 'right'}
                            color="primary"
                        >
                            (${total})
                        </Typography>
                    ) : null}
                </>
            )}
        </Box>
    );
};
